// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".item-card__price .price__cols .price__common{font-size:20px}@media (max-width:800px){.item-card__price .price__cols .price__common{font-size:12px;line-height:14px}}@media (max-width:800px){.item-card__price .price__cols{flex-direction:column-reverse;grid-row-gap:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
